const state = {
  user: {},
  isClickResumeRefreshClose: false
};

const getters = {
  user: state => {
    return state.user
  },
  isClickResumeRefreshClose: state => {
    return state.isClickResumeRefreshClose
  }
};

const actions = {
  setUserInfo(context, val) {
    context.commit('setUserInfo', val);
  },
  setUserInfoAttr(context, obj) {
    context.commit('setUserInfoAttr', obj);
  },
  setResumeRefreshClose(context, val) {
    context.commit('setResumeRefreshClose', val);
  }
};

const mutations = {
  setUserInfo(state, val) {
    state.user = val
  },
  setUserInfoAttr(state, obj) {
    for (let key in obj) {
      state.user[key] = obj[key]
    }
  },
  setResumeRefreshClose(state, val) {
    state.isClickResumeRefreshClose = val
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js